import { render, staticRenderFns } from "./MyProfileRoute.vue?vue&type=template&id=b74aae52&"
import script from "./MyProfileRoute.vue?vue&type=script&lang=ts&"
export * from "./MyProfileRoute.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports